export default __webpack_public_path__ + "static/media/logo.c67c942a.svg";